import { Pipe, PipeTransform } from '@angular/core';
import { Session } from '../models/tracer.model';

@Pipe({ name: 'sessionLastAction' })
export class SessionLastActionPipe implements PipeTransform {
  // Returns the most recent request CreatedAt in the session, falling back to
  // session.updated_at or session.created_at if no requests are loaded.
  transform(session: Session): string {
    let latest = '';
    for (const r of session?.requests ?? []) {
      if (r?.created_at && r.created_at > latest) latest = r.created_at;
    }
    return latest || session?.updated_at || session?.created_at || '';
  }
}
